/** Paso 4 — precio con tarjeta / efectivo. Tarjeta SIEMPRE primero. Sin «recargo» ni «ahorra». */
import { tr } from '@/contexts/LanguageContext';

export const hasCardPrice = (svc) => svc && svc.card_price != null && Number(svc.card_price) > 0;

// «Tarjeta $61.80 · Efectivo $60.00»
export const bothPrices = (cash, card) => tr("Tarjeta ${0} · Efectivo ${1}", Number(card).toFixed(2), Number(cash).toFixed(2));

// Para reservas selladas: booking.pricing {active, cash_price, card_price}
export const bookingPrices = (booking) => {
  const p = booking?.pricing;
  if (!p || !p.active) return null;
  return bothPrices(p.cash_price, p.card_price);
};
